/**
 * A super module that collects available sub-modules.
 *
 * @namespace vef.utils
 * @memberof vef
 */

import * as template from './template/index.js';
export { template };

export * from './utils.js';
export * from './Router.js';
export * from './Site.js';